import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Input, Flex, Text, Box } from '@mafc/trolly';
import { useTranslation } from 'react-i18next';
import { FormErrorTypes, getErrorMsg } from 'utils/form.util';
import { emailRegEx, pakNumberRegex } from 'pages/Checkout/constants/regexps';
import { useForm } from 'react-hook-form';
import COLORS from 'theme/colors';
import TYPOGRAPHY from 'theme/typography';
import { storePaymentDetails } from 'pages/Checkout/redux/actions/payment.action';
import EPaymentMethods from 'pages/Checkout/components/Payment/PamentMethods.enum';
import { useDispatch } from 'react-redux';
import { IAppState } from 'config/redux/reducers';

const EasyPaisa = () => {
  const dispatch = useDispatch();
  const paymentDetails = useSelector((state: IAppState) => state.checkout.payment.paymentDetails);
  const { t } = useTranslation();
  const [easyPaisaAccountDetails, updateEasyPaisaAccountDetail] = useState({
    emailAddress: '',
    mobileNumber: '',
    ...paymentDetails.easyPaisaDetails,
  });
  const { register, errors, getValues } = useForm<any>({
    mode: 'onBlur',
  });

  const handleFieldChange = (key: string) => (e: any) => {
    updateEasyPaisaAccountDetail({
      ...easyPaisaAccountDetails,
      [key]: e.target.value,
    });
  };

  const isValidDetails = useCallback((allValues: any) => {
    return emailRegEx.test(allValues.emailAddress) && pakNumberRegex.test(allValues.mobileNumber);
  }, []);

  const formUpdate = () => {
    const allValues = getValues();
    dispatch(
      storePaymentDetails(EPaymentMethods.MOBILE_WALLET, {
        isValid: isValidDetails(allValues),
        easyPaisaDetails: { ...allValues },
      })
    );
  };
  useEffect(formUpdate, [easyPaisaAccountDetails, dispatch, getValues, isValidDetails]);

  return (
    <Flex flexDirection={'column'} padding={3}>
      <Text.Caption>{t('easyPaisa.formHeading')}</Text.Caption>
      <form>
        <Box
          display={[null, 'flex']}
          flexDirection={'row'}
          flex={1}
          justifyContent={'space-between'}
        >
          <Box width={[1, 1, 1 / 2]} mr={3}>
            <Input
              label={t('easyPaisa.emailAddress')}
              name="emailAddress"
              value={easyPaisaAccountDetails.emailAddress}
              onChange={handleFieldChange('emailAddress')}
              register={register({
                required: getErrorMsg(FormErrorTypes.required, t),
                pattern: {
                  value: emailRegEx,
                  message: t('errorForm.validEmail'),
                },
              })}
            />
            {errors.emailAddress && (
              <Text.Paragraph color={COLORS.RED} mt={1} fontSize={TYPOGRAPHY.SIZE[10]}>
                {errors.emailAddress.message}
              </Text.Paragraph>
            )}
          </Box>
          <Box width={[1, 1, 1 / 2]}>
            <Input
              label={t('easyPaisa.mobileNumber')}
              name="mobileNumber"
              value={easyPaisaAccountDetails.mobileNumber}
              onChange={handleFieldChange('mobileNumber')}
              register={register({
                required: getErrorMsg(FormErrorTypes.required, t),
                pattern: {
                  value: pakNumberRegex,
                  message: t('errorForm.validNumber'),
                },
              })}
            />
            {errors.mobileNumber && (
              <Text.Paragraph color={COLORS.RED} mt={1} fontSize={TYPOGRAPHY.SIZE[10]}>
                {errors.mobileNumber.message}
              </Text.Paragraph>
            )}
          </Box>
        </Box>
      </form>
    </Flex>
  );
};

export default EasyPaisa;
